import queryString from 'querystring';
import axiosInstance from '../../axios-config';

const appointmentsApi = '/api/patients/{0}/appointments';
const getDateFilterPrefApi = '/api/users/{0}/Preferences?names={1}';
const setDateFilterPrefApi = '/api/users/{0}/Preferences';
const getPatientApptNotificationSettingsApi = 'api/patients/{0}/NotificationSettings?type=Appointments';
const upcomingAppointmentsApi = '/api/patients/{0}/upcomingAppointments/count/4';

const filterPreferenceName = 'PatientPortal_AppointmentsFilter_Date';

export const getUpcomingAppointments = (patientId) =>
  axiosInstance.get(upcomingAppointmentsApi
    .replace('{0}', patientId)
  );

export const getAppointments = (patientId, filter) => {
  let qry = queryString.stringify(filter);
  if (qry && qry.length > 0) {
    qry = '&' + qry;
  } else {
    qry = '';
  }

  return axiosInstance.get(appointmentsApi
    .replace('{0}', patientId)
    .replace('{1}', qry));
};

export const setDateFilterPreference = (userId, value) =>
  axiosInstance.put(setDateFilterPrefApi.replace('{0}', userId), {
    userId,
    name: filterPreferenceName,
    value,
  }, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.data);

export const getDateFilterPreference = (userId) =>
  axiosInstance.get(getDateFilterPrefApi
    .replace('{0}', userId)
    .replace('{1}', filterPreferenceName)
  );

export const getPatientApptNotificationSettings = (patientId) =>
  axiosInstance
    .get(getPatientApptNotificationSettingsApi.replace('{0}', patientId))
    .catch((axiosResponse) => {
      const error = axiosResponse.response;
      if (error.status === 404) {
        const data = {
          data: {
            patientSettings: {
              email: false,
              sms: false,
            },
          },
        };
        return Promise.resolve(data);
      }

      return Promise.reject(error);
    });
